module.exports = __webpack_public_path__ + "50a4d96311478e86710af73b097e26dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/training-groups2.jpg
// module id = 1232
// module chunks = 0